import { Box } from "@mui/material";
import { ReactNode, RefObject } from "react";

type DataTableLayoutProps = {
  toolbar?: ReactNode;
  footer?: ReactNode;
  tableRef?: RefObject<HTMLDivElement | null>;
  children: ReactNode;
};

const DataTableLayout = ({
  toolbar,
  footer,
  tableRef,
  children,
}: DataTableLayoutProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: 0,
      }}
    >
      {toolbar ? <Box sx={{ flexShrink: 0 }}>{toolbar}</Box> : null}
      <Box
        ref={tableRef}
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: "auto",
        }}
      >
        {children}
      </Box>
      {footer ? <Box sx={{ flexShrink: 0 }}>{footer}</Box> : null}
    </Box>
  );
};

export default DataTableLayout;
